// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'


// 引入外部样式
import '@/assets/css/index.css'

// 引入element-ui
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'


import http from './components/common/Common'
Vue.prototype.$http = http; //cli3挂载方法

Vue.prototype.$global = {
  host:'https://fyzhst.9313.tv/'
  // host:'http://192.168.0.29:8090'
}; //cli3挂载方法

Vue.config.productionTip = false
Vue.use(ElementUI)
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js